import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Product, PenProduct } from '../../../shared/interfaces/product';
import { PenService } from '../../../admin/services/pen.service';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { PenProductCardComponent } from '../pen-product-card/pen-product-card.component';
import { Cart } from '../../classes/cart';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Sale } from '../../../shared/interfaces/sale';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-display-pen-products',
    standalone: true,
    imports: [CommonModule, PenProductCardComponent],
    templateUrl: './display-pen-products.component.html',
    styleUrl: './display-pen-products.component.scss',
})
export class DisplayPenProductsComponent implements OnInit, OnChanges {
    public aggregated$?: Observable<PenProduct[]>;

    @Input() public sale?: Sale;

    private readonly _products = new BehaviorSubject<Product[]>([]);

    public constructor(
        public readonly cart: Cart,
        private readonly destroyRef: DestroyRef,
        private readonly pen: PenService,
        private readonly cdr: ChangeDetectorRef,
    ) {}

    @Input() public set products(value: Product[]) {
        this._products.next(value);
    }

    public getSelectedProductIdInGroup(group: PenProduct): number | null {
        return group.options.find(product => this.cart.selections[product.id])?.id || null;
    }

    public isGroupSelected(group: PenProduct): boolean {
        return group.options.some(product => this.cart.selections[product.id]);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['sale']) {
            this.cdr.markForCheck();
        }
    }

    public ngOnInit(): void {
        this.aggregated$ = this._products.pipe(
            takeUntilDestroyed(this.destroyRef),
            map((products) => this.pen.aggregate(products)),
        );

        this.cart.changed.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe(() => this.cdr.markForCheck());
    }

    public onGroupSelectionChange(group: PenProduct, selectedId: number): void {
        this.resetGroupSelection(group);

        const selected = group.options.find(p => p.id === selectedId);
        if (selected) {
            this.cart.toggle(selected);
        }
    }

    public resetGroupSelection(group: PenProduct): void {
        group.options.forEach((product) => this.cart.remove(product));
    }
}
